var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlleviLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2052.51 1953.65",
    fill: "#A45217",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2008.26,1463.82l-210.92,365.4c-83,143.48-290.07,143.48-372.81,0L1207.3,1454.57c-26.17-45.14-91.38-45-117.4.19L874.62,1828.91A215,215,0,0,1,688.1,1936.76H442.21a215.06,215.06,0,0,1-186.53-107.85L44.53,1461.6c-82.5-143.48,21-322.35,186.52-322.35h794L564.61,339.66C481.87,196.18,585.41,16.83,750.89,16.83h421.84a215.58,215.58,0,0,1,186.51,107.61l649,1124.16A216.17,216.17,0,0,1,2008.26,1463.82Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlleviLogo);
export default __webpack_public_path__ + "static/media/allevi_logo.2ba4bde765eacec2ad6a4216158e24d7.svg";
export { ForwardRef as ReactComponent };